import AgendaTouchpoint from './components/AgendaTouchpoint';

export default AgendaTouchpoint;
